import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (data) => dispatch => 
{
    // console.log(data);
    axios.get('delegate_deposit/list', {params: data})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.LIST,
            value: response.data
        })
    })
    .catch(err => 
    {
    
    });
}

export const store = (data) => dispatch => 
{
    // console.log(data);
    axios.post('delegate_deposit/store', data)
    .then(function (response) 
    {
        // console.log(response);
        dispatch (
        {
            type: actionType.STORE,
            value: response.data
        });
    })
    .catch(err => 
    {
        
    });
}

export const getDropDown = (data) => (dispatch, getState) =>
{
    axios.get('delegate_deposit/drop_down', {params: data})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.DROPDOWN,
            value: response.data
        });
    })
    .catch(err => 
    {
    
    });
}

export const initDelegateDepositInitialLoading = (data) => (dispatch) => 
{
    dispatch({
        type: actionType.INIT_DELEGATE_DEPOSIT_INITIAL_LOADING,
        payload: data,
    });
}

export const setDelegateDepositInitialLoading = (data) => (dispatch) => {
    dispatch({
        type: actionType.SET_DELEGATE_DEPOSIT_INITIAL_LOADING,
        page: data,
    });
}

export const setDelegateDepositLocalState = (data) => (dispatch) => 
{
    let currentPage = data.currentPage;
    // console.log(currentPage)
    switch (currentPage) 
    {
        case "quota_deposit":
            dispatch({
                type: actionType.SET_DELEGATE_DEPOSIT_QUOTA_LOCAL_STATE,
                payload: data,
            });
        break;
        case "deposit_history":
            dispatch({
                type: actionType.SET_DELEGATE_DEPOSIT_HISTORY_LOCAL_STATE,
                payload: data,
            });
        break;
    }
}

export const getCurrencyExchange = (data) => dispatch => {
    axios.post('delegate_deposit/currency_exchange', data)
    .then((res) => {
        dispatch({
            type: actionType.CURRENCY_EXCHANGE,
            payload: res.data
        });
    })
    .catch((err) => {

    });
}